{
  "INBOX_MGMT": {
    "HEADER": "Indbakker",
    "DESCRIPTION": "A channel is the mode of communication your customer chooses to interact with you. An inbox is where you manage interactions for a specific channel. It can include communications from various sources such as email, live chat, and social media.",
    "LEARN_MORE": "Learn more about inboxes",
    "RECONNECT": {
      "BUTTON": "Forbind igen",
      "FACEBOOK": "Forbindelsen til Facebook er udløbet eller tilbagekaldt. Beskeder til siden når ikke frem til denne indbakke, og svar kan mislykkes. En person, der administrerer Facebook-siden, skal klikke på Forbind igen og logge ind på Facebook.",
      "INSTAGRAM": "Forbindelsen til Instagram er udløbet eller tilbagekaldt. Beskeder til kontoen når ikke frem til denne indbakke, og svar kan mislykkes. Klik på Forbind igen, og log ind på den samme Instagram-konto. En anden konto opretter en ny indbakke.",
      "GOOGLE": "Forbindelsen til Google er udløbet eller tilbagekaldt. Nye e-mails når ikke frem til denne indbakke, og svar kan mislykkes. Klik på Forbind igen, og log ind på Google som {email}.",
      "MICROSOFT": "Forbindelsen til Microsoft er udløbet eller tilbagekaldt. Nye e-mails når ikke frem til denne indbakke, og svar kan mislykkes. Klik på Forbind igen, og log ind på Microsoft som {email}.",
      "ALLEGRO": "Forbindelsen til Allegro er udløbet eller tilbagekaldt. Beskeder fra købere når ikke frem til denne indbakke, og svar kan mislykkes. Klik på Forbind igen, og log ind på Allegro som sælgeren {seller}. En anden sælgerkonto opretter en ny indbakke.",
      "IMAP_LOGIN": "Mailserveren afviser IMAP-loginet {login}. Nye e-mails kommer ikke frem til denne indbakke. Tjek IMAP-loginet og adgangskoden under fanen {tab}, og gem dem. Vi bliver ved med at prøve at logge ind, og indbakken kommer sig, så snart loginet virker.",
      "WHATSAPP": "Forbindelsen til WhatsApp er udløbet eller tilbagekaldt. Vedhæftede filer fra kunder når ikke frem til denne indbakke, og svar kan mislykkes. Klik på Forbind igen, log ind på Facebook, og vælg nummeret {phone} igen."
    },
    "LIST": {
      "404": "Der er ingen indbakker tilknyttet denne konto.",
      "RECONNECT_REQUIRED": "Skal forbindes igen"
    },
    "CREATE_FLOW": {
      "CHANNEL": {
        "TITLE": "Vælg Kanal",
        "BODY": "Vælg den udbyder, du vil integrere med chatten."
      },
      "INBOX": {
        "TITLE": "Opret Indbakke",
        "BODY": "Autentificer din konto og opret en indbakke."
      },
      "AGENT": {
        "TITLE": "Tilføj Agenter",
        "BODY": "Tilføj agenter til den oprettede indbakke."
      },
      "FINISH": {
        "TITLE": "Voilà!",
        "BODY": "Så er alt klart!"
      }
    },
    "ADD": {
      "CHANNEL_NAME": {
        "LABEL": "Indbakke Navn",
        "PLACEHOLDER": "Indtast dit indbakke navn (f. eks. Acme Inc)",
        "ERROR": "Angiv et gyldigt indbakke navn"
      },
      "WEBSITE_NAME": {
        "LABEL": "Websted Navn",
        "PLACEHOLDER": "Indtast dit websted navn (fx: Firma ApS)"
      },
      "INTERNAL_NAME": {
        "LABEL": "Internt navn",
        "PLACEHOLDER": "Navngiv indbakken, som den vises i dette dashboard",
        "ERROR": "Angiv et unikt internt navn"
      },
      "FB": {
        "HELP": "PS: Ved at logge ind får vi kun adgang til din sides beskeder. Vi kan aldrig få adgang til dine private beskeder.",
        "CHOOSE_PAGE": "Vælg Side",
        "CHOOSE_PLACEHOLDER": "Vælg en side fra listen",
        "INBOX_NAME": "Indbakke Navn",
        "ADD_NAME": "Tilføj et navn til din indbakke",
        "PICK_NAME": "Pick a Name for your Inbox",
        "PICK_A_VALUE": "Vælg en værdi",
        "CREATE_INBOX": "Opret indbakke"
      },
      "INSTAGRAM": {
        "CONTINUE_WITH_INSTAGRAM": "Fortsæt med Instagram",
        "CONNECT_YOUR_INSTAGRAM_PROFILE": "Forbind din Instagram-profil",
        "HELP": "For at tilføje din Instagram-profil som en kanal skal du godkende din Instagram-profil ved at klikke på 'Fortsæt med Instagram' ",
        "ERROR_MESSAGE": "Der opstod en fejl under forbindelsen til Instagram, prøv igen",
        "ERROR_AUTH": "Der opstod en fejl under forbindelsen til Instagram, prøv igen",
        "NEW_INBOX_SUGGESTION": "Denne Instagram-konto var tidligere tilknyttet en anden indbakke og er nu blevet flyttet hertil. Alle nye beskeder vil vises her. Den gamle indbakke kan ikke længere sende eller modtage beskeder for denne konto.",
        "DUPLICATE_INBOX_BANNER": "Denne Instagram-konto er blevet flyttet til den nye Instagram-kanal-indbakke. Du kan ikke længere sende/modtage Instagram-beskeder fra denne indbakke."
      },
      "TWITTER": {
        "HELP": "For at tilføje din Twitter-profil som en kanal, skal du godkende din Twitter-profil ved at klikke på 'Log ind med Twitter' ",
        "ERROR_MESSAGE": "Der opstod en fejl under forbindelsen til Twitter. Prøv igen",
        "TWEETS": {
          "ENABLE": "Opret samtaler fra nævnte Tweets"
        }
      },
      "WEBSITE_CHANNEL": {
        "TITLE": "Hjemmesidekanal",
        "DESC": "Opret en kanal til din hjemmeside og begynde at supporte dine kunder via vores hjemmeside widget.",
        "LOADING_MESSAGE": "Opretter Website Support Kanal",
        "CHANNEL_AVATAR": {
          "LABEL": "Kanal Avatar"
        },
        "CHANNEL_WEBHOOK_URL": {
          "LABEL": "Webhook URL",
          "PLACEHOLDER": "Please enter your Webhook URL",
          "ERROR": "Angiv en gyldig URL"
        },
        "CHANNEL_DOMAIN": {
          "LABEL": "Hjemmeside Domæne",
          "PLACEHOLDER": "Indtast dit website domæne (fx: ditfirma.dk)"
        },
        "CHANNEL_WELCOME_TITLE": {
          "LABEL": "Velkomstoverskrift",
          "PLACEHOLDER": "Hejsa!"
        },
        "CHANNEL_WELCOME_TAGLINE": {
          "LABEL": "Velkomst Tagline",
          "PLACEHOLDER": "Vi gør det nemt at komme i kontakt med os. Spørg os om noget, eller del din feedback."
        },
        "CHANNEL_GREETING_MESSAGE": {
          "LABEL": "Kanal start hilsen besked",
          "PLACEHOLDER": "Dit firma ApS svarer typisk på et par timer."
        },
        "CHANNEL_GREETING_TOGGLE": {
          "LABEL": "Aktivér kanal start hilsen",
          "HELP_TEXT": "Send automatisk en hilsen når en ny samtale er oprettet.",
          "ENABLED": "Aktiveret",
          "DISABLED": "Deaktiveret"
        },
        "REPLY_TIME": {
          "TITLE": "Angiv svartid",
          "IN_A_FEW_MINUTES": "På nogle få minutter",
          "IN_A_FEW_HOURS": "Om et par timer",
          "IN_A_DAY": "På en dag",
          "HELP_TEXT": "Denne svartid vil blive vist på live chat widget"
        },
        "WIDGET_COLOR": {
          "LABEL": "Widget Farve",
          "PLACEHOLDER": "Opdater widget farve der bruges i widget"
        },
        "SUBMIT_BUTTON": "Opret indbakke",
        "API": {
          "ERROR_MESSAGE": "Vi var ikke i stand til at oprette en hjemmeside kanal, prøv igen"
        }
      },
      "TWILIO": {
        "TITLE": "Twilio SMS/Whatsapp Kanal",
        "DESC": "Integrer Twilio og start med at supportere dine kunder via SMS eller Whatsapp.",
        "ACCOUNT_SID": {
          "LABEL": "Konto SID",
          "PLACEHOLDER": "Indtast venligst din Twilio konto SID",
          "ERROR": "Dette felt er påkrævet"
        },
        "API_KEY": {
          "USE_API_KEY": "Use API Key Authentication",
          "LABEL": "API Key SID",
          "PLACEHOLDER": "Please enter your API Key SID",
          "ERROR": "Dette felt er påkrævet"
        },
        "API_KEY_SECRET": {
          "LABEL": "API Key Secret",
          "PLACEHOLDER": "Please enter your API Key Secret",
          "ERROR": "Dette felt er påkrævet"
        },
        "MESSAGING_SERVICE_SID": {
          "LABEL": "SID For Beskedtjeneste",
          "PLACEHOLDER": "Indtast venligst din Twilio Messaging Service SID",
          "ERROR": "Dette felt er påkrævet",
          "USE_MESSAGING_SERVICE": "Brug en Twilio-meddelelsestjeneste"
        },
        "CHANNEL_TYPE": {
          "LABEL": "Kanaltype",
          "ERROR": "Vælg venligst din kanaltype"
        },
        "AUTH_TOKEN": {
          "LABEL": "Auth Token",
          "PLACEHOLDER": "Indtast venligst din Twilio Auth Token",
          "ERROR": "Dette felt er påkrævet"
        },
        "CHANNEL_NAME": {
          "LABEL": "Indbakke Navn",
          "PLACEHOLDER": "Indtast venligst et indbakke navn",
          "ERROR": "Dette felt er påkrævet"
        },
        "PHONE_NUMBER": {
          "LABEL": "Telefonnummer",
          "PLACEHOLDER": "Indtast venligst det telefonnummer, hvorfra beskeden vil blive sendt.",
          "ERROR": "Please provide a valid phone number that starts with a `+` sign and does not contain any spaces."
        },
        "API_CALLBACK": {
          "TITLE": "Callback URL",
          "SUBTITLE": "Du er nødt til at konfigurere besked callback URL i Twilio med den URL, der er nævnt her."
        },
        "SUBMIT_BUTTON": "Opret Twilio Kanal",
        "API": {
          "ERROR_MESSAGE": "Vi var ikke i stand til at godkende Twilio legitimationsoplysninger, prøv igen"
        }
      },
      "SMS": {
        "TITLE": "SMS Kanal",
        "DESC": "Begynd at støtte dine kunder via SMS.",
        "PROVIDERS": {
          "LABEL": "API Provider",
          "TWILIO": "Twilio",
          "BANDWIDTH": "Båndbredde",
          "SMS_BRANA": "SMS Brana",
          "DIDWW": "DIDWW"
        },
        "API": {
          "ERROR_MESSAGE": "Vi kunne ikke gemme SMS-kanalen"
        },
        "BANDWIDTH": {
          "ACCOUNT_ID": {
            "LABEL": "Konto SID",
            "PLACEHOLDER": "Indtast venligst dit Båndbredde Konto ID",
            "ERROR": "Dette felt er påkrævet"
          },
          "API_KEY": {
            "LABEL": "API Nøgle",
            "PLACEHOLDER": "Please enter your Bandwidth API Key",
            "ERROR": "Dette felt er påkrævet"
          },
          "API_SECRET": {
            "LABEL": "API Hemmelighed",
            "PLACEHOLDER": "Please enter your Bandwidth API Secret",
            "ERROR": "Dette felt er påkrævet"
          },
          "APPLICATION_ID": {
            "LABEL": "Applikations ID",
            "PLACEHOLDER": "Indtast venligst dit Båndbredde-program-id",
            "ERROR": "Dette felt er påkrævet"
          },
          "INBOX_NAME": {
            "LABEL": "Indbakke Navn",
            "PLACEHOLDER": "Indtast venligst et indbakke navn",
            "ERROR": "Dette felt er påkrævet"
          },
          "PHONE_NUMBER": {
            "LABEL": "Telefonnummer",
            "PLACEHOLDER": "Indtast venligst det telefonnummer, hvorfra beskeden vil blive sendt.",
            "ERROR": "Please provide a valid phone number that starts with a `+` sign and does not contain any spaces."
          },
          "SUBMIT_BUTTON": "Opret Båndbredde Kanal",
          "API": {
            "ERROR_MESSAGE": "Vi var ikke i stand til at godkende Twilio legitimationsoplysninger, prøv igen"
          },
          "API_CALLBACK": {
            "TITLE": "Callback URL",
            "SUBTITLE": "Du skal konfigurere beskedtilbagekalds-URL'en i Båndbredde med den URL, der er nævnt her."
          }
        },
        "SMS_BRANA": {
          "INBOX_NAME": {
            "LABEL": "Indbakkenavn",
            "PLACEHOLDER": "Angiv et indbakkenavn",
            "ERROR": "Dette felt er påkrævet"
          },
          "PHONE_NUMBER": {
            "LABEL": "Telefonnummer",
            "PLACEHOLDER": "Angiv det telefonnummer, som beskeder skal sendes fra.",
            "ERROR": "Angiv et gyldigt telefonnummer, der starter med et `+`-tegn."
          },
          "SUBMIT_BUTTON": "Opret SMS Brana-kanal",
          "API": {
            "ERROR_MESSAGE": "Vi kunne ikke oprette SMS Brana-kanalen"
          }
        },
        "DIDWW": {
          "INBOX_NAME": {
            "LABEL": "Indbakkenavn",
            "PLACEHOLDER": "Angiv et indbakkenavn",
            "ERROR": "Dette felt er påkrævet"
          },
          "PHONE_NUMBER": {
            "LABEL": "Telefonnummer",
            "PLACEHOLDER": "Angiv det telefonnummer, som beskeder skal sendes fra.",
            "ERROR": "Angiv et gyldigt telefonnummer, der starter med et `+`-tegn."
          },
          "SUBMIT_BUTTON": "Opret DIDWW-kanal",
          "API": {
            "ERROR_MESSAGE": "Vi kunne ikke oprette DIDWW-kanalen"
          }
        }
      },
      "WHATSAPP": {
        "PROVIDERS": {
          "LABEL": "API Provider",
          "WHATSAPP_CLOUD": "WhatsApp Sky"
        },
        "API_CALLBACK": {
          "SUBTITLE": "Du skal konfigurere dit webhook URL og verifikations token, i Facebook Developer portal med værdierne vist nedenfor.",
          "WEBHOOK_URL": "Webhook URL",
          "WEBHOOK_VERIFICATION_TOKEN": "Webhook verifikations token"
        },
        "EMBEDDED_SIGNUP": {
          "TITLE": "Hurtig opsætning med Meta",
          "DESC": "Du bliver omdirigeret til Meta for at logge ind på din WhatsApp Business-konto. Adgang som administrator gør opsætningen nemmere og hurtigere.",
          "BENEFITS": {
            "EASY_SETUP": "Ingen manuel konfiguration påkrævet",
            "SECURE_AUTH": "Sikker OAuth-baseret godkendelse",
            "AUTO_CONFIG": "Automatisk konfiguration af webhook og telefonnummer"
          },
          "SUBMIT_BUTTON": "Opret forbindelse med WhatsApp Business",
          "AUTH_PROCESSING": "Godkender med Meta",
          "WAITING_FOR_BUSINESS_INFO": "Fuldfør venligst virksomhedsopsætningen i Meta-vinduet...",
          "PROCESSING": "Opsætter din WhatsApp Business-konto",
          "CANCELLED": "WhatsApp-tilmeldingen blev annulleret",
          "WAITING_FOR_AUTH": "Venter på godkendelse...",
          "INVALID_BUSINESS_DATA": "Ugyldige virksomhedsdata modtaget fra Facebook. Prøv venligst igen.",
          "SIGNUP_ERROR": "Der opstod en fejl ved tilmeldingen",
          "SDK_LOAD_ERROR": "Facebook SDK kunne ikke indlæses. Prøv igen.",
          "AUTH_NOT_COMPLETED": "Godkendelsen blev ikke fuldført. Genstart venligst processen.",
          "SUCCESS_FALLBACK": "WhatsApp Business-kontoen er blevet konfigureret",
          "RECONNECTED": "WhatsApp-kanalen er blevet forbundet igen"
        },
        "API": {
          "ERROR_MESSAGE": "Vi kunne ikke gemme WhatsApp-kanalen"
        }
      },
      "API_CHANNEL": {
        "TITLE": "API Kanal",
        "DESC": "Integrer med API-kanal og begynd at supportere dine kunder.",
        "CHANNEL_NAME": {
          "LABEL": "Kanalnavn",
          "PLACEHOLDER": "Indtast et kanalnavn",
          "ERROR": "Dette felt er påkrævet"
        },
        "WEBHOOK_URL": {
          "LABEL": "Webhook URL",
          "SUBTITLE": "Configure the URL where you want to receive callbacks on events.",
          "PLACEHOLDER": "Webhook URL"
        },
        "SUBMIT_BUTTON": "Opret API-kanal",
        "API": {
          "ERROR_MESSAGE": "Vi var ikke i stand til at gemme api kanalen"
        }
      },
      "SALESFORCE_CHANNEL": {
        "TITLE": "Salesforce-kanal",
        "DESC": "Integrer med Salesforce-kanalen og begynd at supportere dine kunder.",
        "CHANNEL_NAME": {
          "LABEL": "Kanalnavn",
          "PLACEHOLDER": "Angiv et kanalnavn",
          "ERROR": "Dette felt er påkrævet"
        },
        "API_BASE_URL": {
          "LABEL": "Salesforce API-URL",
          "SUBTITLE": "Konfigurer basis-URL'en for din Salesforce-instans.",
          "PLACEHOLDER": "Salesforce API-URL"
        },
        "KEY_ID": {
          "LABEL": "Nøgle-ID",
          "SUBTITLE": "Nøgle-ID for din Salesforce-kanal.",
          "PLACEHOLDER": "NØGLE-ID"
        },
        "SECRET": {
          "LABEL": "Hemmelighed",
          "SUBTITLE": "Hemmelighed for din Salesforce-kanal.",
          "PLACEHOLDER": "*****"
        },
        "SUBMIT_BUTTON": "Opret Salesforce-kanal",
        "API": {
          "ERROR_MESSAGE": "Vi kunne ikke gemme Salesforce-kanalen"
        },
        "API_CALLBACK": {
          "TITLE": "Webhook URL",
          "SUBTITLE": "Du skal konfigurere webhook-URL'en i Salesforce med den URL, der er nævnt her."
        },
        "BEARER_TOKEN": {
          "TITLE": "Bearer Token",
          "SUBTITLE": "Brug dette bearer token til godkendelse, når du konfigurerer webhooket i Salesforce."
        },
        "OVERRIDE_EMAIL_SENDER": {
          "TITLE": "Tilsidesæt afsender-e-mail",
          "SUBTITLE": "Hvis angivet, bruges denne e-mailadresse som afsender for alle udgående e-mails i stedet for samtalens oprindelige e-mailadresse.",
          "PLACEHOLDER": "f.eks. support{'@'}example.com"
        }
      },
      "ALLEGRO_CHANNEL": {
        "TITLE": "Allegro-kanal",
        "DESC": "Forbind en Allegro-sælgerkonto, og besvar dens beskedcenter fra kontaktcentret.",
        "CHANNEL_NAME": {
          "LABEL": "Indbakkenavn",
          "SUBTITLE": "Navnet, som agenter ser for denne indbakke.",
          "PLACEHOLDER": "Indtast et indbakkenavn",
          "ERROR": "Dette felt er påkrævet"
        },
        "SUBMIT_BUTTON": "Log ind med Allegro",
        "API": {
          "ERROR_MESSAGE": "Der opstod en fejl ved forbindelsen til Allegro, prøv venligst igen"
        },
        "SELLER_LOGIN": {
          "TITLE": "Allegro-login",
          "SUBTITLE": "Den sælgerkonto, som denne indbakke læser og besvarer beskeder for."
        }
      },
      "KAUFLAND_CHANNEL": {
        "TITLE": "Kaufland-kanal",
        "DESC": "Besvar de ticket-beskeder, som købere sender dig på Kaufland-markedspladsen.",
        "CHANNEL_NAME": {
          "LABEL": "Kanalnavn",
          "PLACEHOLDER": "Indtast et kanalnavn",
          "ERROR": "Dette felt er påkrævet"
        },
        "CLIENT_KEY": {
          "LABEL": "Client Key",
          "SUBTITLE": "Den 32 tegn lange Client Key fra API-indstillingssiden på din Kaufland-sælgerkonto.",
          "PLACEHOLDER": "32 tegn lang nøgle",
          "ERROR": "Indtast den 32 tegn lange Client Key"
        },
        "SECRET_KEY": {
          "LABEL": "Secret Key",
          "SUBTITLE": "Den 64 tegn lange Secret Key, der hører til din Client Key. Kaufland viser den én gang, og den sendes aldrig tilbage til denne side.",
          "PLACEHOLDER": "64 tegn lang nøgle",
          "ERROR": "Indtast den 64 tegn lange Secret Key"
        },
        "SUBMIT_BUTTON": "Opret Kaufland-kanal",
        "API": {
          "ERROR_MESSAGE": "Vi kunne ikke gemme Kaufland-kanalen"
        },
        "DISCONNECTED": {
          "TITLE": "Afbrudt",
          "MESSAGE": "Kaufland afviste disse API-nøgler. Indtast Client Key og Secret Key igen for at genoprette forbindelsen til denne indbakke."
        }
      },
      "EMAIL_CHANNEL": {
        "TITLE": "E-mail Kanal",
        "DESC": "Integrate your email inbox.",
        "CHANNEL_NAME": {
          "LABEL": "Kanalnavn",
          "PLACEHOLDER": "Indtast et kanalnavn",
          "ERROR": "Dette felt er påkrævet"
        },
        "EMAIL": {
          "LABEL": "E-mail",
          "SUBTITLE": "E-mail hvor dine kunder sender dig support tickets",
          "PLACEHOLDER": "E-mail"
        },
        "SUBMIT_BUTTON": "Opret E-Mail Kanal",
        "API": {
          "ERROR_MESSAGE": "Vi kunne ikke gemme e-mailkanalen"
        },
        "FINISH_MESSAGE": "Begynd at videresende dine e-mails til følgende e-mailadresse."
      },
      "LINE_CHANNEL": {
        "TITLE": "LINE Kanal",
        "DESC": "Integrér med LINE-kanalen og begynd at støtte dine kunder.",
        "CHANNEL_NAME": {
          "LABEL": "Kanalnavn",
          "PLACEHOLDER": "Indtast et kanalnavn",
          "ERROR": "Dette felt er påkrævet"
        },
        "LINE_CHANNEL_ID": {
          "LABEL": "LINE Kanal ID",
          "PLACEHOLDER": "LINE Kanal ID"
        },
        "LINE_CHANNEL_SECRET": {
          "LABEL": "LINE Kanal Hemmelighed",
          "PLACEHOLDER": "LINE Kanal Hemmelighed"
        },
        "LINE_CHANNEL_TOKEN": {
          "LABEL": "LINE Kanal Token",
          "PLACEHOLDER": "LINE Kanal Token"
        },
        "SUBMIT_BUTTON": "Opret LINE Kanal",
        "API": {
          "ERROR_MESSAGE": "Vi var ikke i stand til at gemme LINE kanalen"
        },
        "API_CALLBACK": {
          "TITLE": "Callback URL",
          "SUBTITLE": "Du skal indstille webhook URL i LINE programmet med URL-adressen nævnt her."
        }
      },
      "TELEGRAM_CHANNEL": {
        "TITLE": "Telegram Kanal",
        "DESC": "Integrér med Telegram-kanalen og begynd at støtte dine kunder.",
        "BOT_TOKEN": {
          "LABEL": "Bot Token",
          "SUBTITLE": "Konfigurer den bot token du har fået fra Telegram BotFather.",
          "PLACEHOLDER": "Bot Token"
        },
        "SUBMIT_BUTTON": "Opret Telegram Kanal",
        "API": {
          "ERROR_MESSAGE": "Vi var ikke i stand til at gemme telegram kanal"
        }
      },
      "PHONE_CHANNEL": {
        "TITLE": "Telefonopkald",
        "DESC": "Vælg hvilke telefonopkald der skal vises under denne indbakke.",
        "NAME": {
          "LABEL": "Indbakkenavn",
          "SUBTITLE": "Vælg et let genkendeligt navn."
        },
        "PHONE_NUMBER": {
          "LABEL": "Telefonnummer",
          "SUBTITLE": "Angiv telefonnumre, der hører til denne indbakke. Du kan tilføje flere numre senere.",
          "PLACEHOLDER": "+421123908635"
        },
        "SUBMIT_BUTTON": "Opret indbakke til telefonopkald",
        "API": {
          "ERROR_MESSAGE": "Vi kunne ikke oprette indbakken"
        }
      },
      "AUTH": {
        "TITLE": "Vælg en kanal",
        "DESC": "Chatten understøtter live-chat-widgets, Facebook Messenger, WhatsApp, E-mails, osv., som kanaler. Hvis du ønsker at bygge en brugerdefineret kanal, kan du oprette den ved hjælp af API-kanalen. For at komme i gang, vælg en af kanalerne nedenfor."
      },
      "AGENTS": {
        "TITLE": "Agenter",
        "DESC": "Her kan du tilføje agenter til at håndtere din nyoprettede indbakke. Kun disse valgte agenter vil have adgang til din indbakke. Agenter som ikke er en del af denne indbakke, vil ikke kunne se eller reagere på beskeder i denne indbakke, når de logger ind. <br> <b>PS:</b> Som administrator, hvis du har brug for adgang til alle indbakker, bør du tilføje dig selv som agent til alle indbakker, du opretter.",
        "VALIDATION_ERROR": "Add at least one agent to your new Inbox",
        "PICK_AGENTS": "Vælg agenter for indbakken"
      },
      "DETAILS": {
        "TITLE": "Indbakke Detaljer",
        "DESC": "Vælg den Facebook-side, du vil forbinde til chatten, fra dropdown listen nedenfor. Du kan også give et brugerdefineret navn til din indbakke for bedre identifikation."
      },
      "FINISH": {
        "TITLE": "Du klarede det!",
        "DESC": "Du er færdig med at integrere din Facebook-side med chatten. Næste gang en kunde sender en meddelelse til din side, vil samtalen automatisk dukke op i din indbakke.<br>Vi giver dig også et widget script, som du nemt kan tilføje til din hjemmeside. Når dette er live på din hjemmeside, kan kunder sende dig en besked direkte fra din hjemmeside uden hjælp fra et eksternt værktøj, og samtalen vises lige her, i chatten.<br>Cool, var? Nå ikke, vi forsøge at være :)"
      },
      "EMAIL_PROVIDER": {
        "TITLE": "Select your email provider",
        "DESCRIPTION": "Select an email provider from the list below. If you don't see your email provider in the list, you can select the other provider option and provide the IMAP and SMTP Credentials."
      },
      "MICROSOFT": {
        "TITLE": "Microsoft Email",
        "DESCRIPTION": "Click on the Sign in with Microsoft button to get started. You will redirected to the email sign in page. Once you accept the requested permissions, you would be redirected back to the inbox creation step.",
        "EMAIL_PLACEHOLDER": "Enter email address",
        "SIGN_IN": "Sign in with Microsoft",
        "ERROR_MESSAGE": "There was an error connecting to Microsoft, please try again"
      },
      "GOOGLE": {
        "TITLE": "Google Email",
        "DESCRIPTION": "Click on the Sign in with Google button to get started. You will redirected to the email sign in page. Once you accept the requested permissions, you would be redirected back to the inbox creation step.",
        "SIGN_IN": "Sign in with Google",
        "EMAIL_PLACEHOLDER": "Enter email address",
        "ERROR_MESSAGE": "There was an error connecting to Google, please try again"
      }
    },
    "DETAILS": {
      "LOADING_FB": "Autentificerer dig med Facebook...",
      "ERROR_FB_LOADING": "Error loading Facebook SDK. Please disable any ad-blockers and try again from a different browser.",
      "ERROR_FB_AUTH": "Noget gik galt, Opdatér siden...",
      "ERROR_FB_UNAUTHORIZED": "You're not authorized to perform this action. ",
      "ERROR_FB_UNAUTHORIZED_HELP": "Please ensure you have access to the Facebook page with full control. You can read more about Facebook roles <a href=\" https://www.facebook.com/help/187316341316631\">here</a>.",
      "ERROR_CHANNEL_CREATION": "Vi kunne ikke oprette indbakken. Prøv igen.",
      "CREATING_CHANNEL": "Opretter din indbakke...",
      "TITLE": "Indstil Indbakkedetaljer",
      "DESC": ""
    },
    "AGENTS": {
      "BUTTON_TEXT": "Tilføj agenter",
      "ADD_AGENTS": "Tilføjer agenter til din indbakke..."
    },
    "FINISH": {
      "TITLE": "Din indbakke er klar!",
      "MESSAGE": "Du kan nu engagere dig med dine kunder gennem din nye kanal. Glædelig supportering",
      "BUTTON_TEXT": "Tag mig med dertil",
      "MORE_SETTINGS": "Flere indstillinger",
      "WEBSITE_SUCCESS": "Du er færdig med at oprette en hjemmeside kanal. Kopier koden vist nedenfor og indsæt den på din hjemmeside. Næste gang en kunde bruger live chat, vil samtalen automatisk vises i din indbakke."
    },
    "REAUTH": "Genautorisér",
    "VIEW": "Vis",
    "EDIT": {
      "API": {
        "SUCCESS_MESSAGE": "Indbakkeindstillinger opdateret",
        "AUTO_ASSIGNMENT_SUCCESS_MESSAGE": "Automatisk tildeling opdateret",
        "ERROR_MESSAGE": "Indbakkeindstillingerne kunne ikke opdateres. Prøv igen senere."
      },
      "EMAIL_COLLECT_BOX": {
        "ENABLED": "Aktiveret",
        "DISABLED": "Deaktiveret"
      },
      "ENABLE_CSAT": {
        "ENABLED": "Aktiveret",
        "DISABLED": "Deaktiveret"
      },
      "ENABLE_CSAT_ON_EACH_MESSAGE": {
        "ENABLED": "Aktiveret",
        "DISABLED": "Deaktiveret"
      },
      "SENDER_NAME_SECTION": {
        "TITLE": "Sender name",
        "SUB_TEXT": "Select the name shown to your customer when they receive emails from your agents.",
        "FOR_EG": "For eg:",
        "FRIENDLY": {
          "TITLE": "Friendly",
          "FROM": "fra",
          "SUBTITLE": "Add the name of the agent who sent the reply in the sender name to make it friendly."
        },
        "PROFESSIONAL": {
          "TITLE": "Professional",
          "SUBTITLE": "Use only the configured business name as the sender name in the email header."
        },
        "BUSINESS_NAME": {
          "BUTTON_TEXT": "+ Configure your business name",
          "PLACEHOLDER": "Enter your business name",
          "SAVE_BUTTON_TEXT": "Save"
        }
      },
      "ALLOW_MESSAGES_AFTER_RESOLVED": {
        "ENABLED": "Aktiveret",
        "DISABLED": "Deaktiveret"
      },
      "ENABLE_CONTINUITY_VIA_EMAIL": {
        "ENABLED": "Aktiveret",
        "DISABLED": "Deaktiveret"
      },
      "RESPOND_FROM_EMAIL": {
        "NONE": "Ingen"
      },
      "LOCK_TO_SINGLE_CONVERSATION": {
        "ENABLED": "Aktiveret",
        "DISABLED": "Deaktiveret"
      },
      "ENABLE_HMAC": {
        "LABEL": "Aktiver"
      },
      "FORCE_NEW_CONVERSATION_PER_LOAD": {
        "ENABLED": "Aktiveret",
        "DISABLED": "Deaktiveret"
      },
      "NEW_CONVERSATION_FORGETS_CONTACT": {
        "ENABLED": "Aktiveret",
        "DISABLED": "Deaktiveret"
      },
      "ENABLE_EMAIL_FETCHING": {
        "LABEL": "Aktiver synkronisering af indgående e-mails"
      },
      "ENABLE_CUSTOM_EMAIL": {
        "LABEL": "Aktiver tilpasset e-maildomæne (betalt tjeneste)."
      },
      "ENABLE_FACEBOOK_COMMENTS": {
        "LABEL": "Aktiver behandling af Facebook-kommentarer"
      },
      "SIGNATURE": {
        "TITLE": "HTML-signatur",
        "SUB_TEXT": "Denne signatur tilføjes til bunden af hver besked, der sendes fra denne indbakke.",
        "HTML_CONTENT": "HTML-kode",
        "HTML_CONTENT_HELP": "{'{{'}name{'}}'} erstattes med agentens navn.\n{'{{'}email{'}}'} erstattes med e-mailadressen på den agent, der sendte e-mailen.\n{'{{'}position{'}}'} erstattes med agentens stilling.\n{'{{'}custom_line{'}}'} erstattes med agentens tilpassede linje.\n{'{{'}email_signature_picture{'}}'} erstattes med URL-adressen til agentens billede til e-mailsignaturen (ikke et img-tag) — brug den som billedkilde (src i et img-tag).",
        "PREVIEW": "Forhåndsvisning"
      },
      "COUNTRY_SIGNATURES": {
        "TITLE": "Signaturer pr. land",
        "SUB_TEXT": "Et svar får signaturen for købers land.",
        "HELP": "Et svar signeres efter samtalens land: Kaufland-butikken, markedspladsen for Allegro-ordren, eller ellers det sprog, køberen skriver på. Når landet er ukendt eller ikke har nogen signatur her, bruges HTML-signaturen ovenfor. Markedspladser forbyder links til din hjemmeside og kontaktoplysninger, så nøjes med en hilsen og {'{{'}name{'}}'}.",
        "EMPTY": "Du har endnu ingen landesignaturer, så svar bruger HTML-signaturen ovenfor.",
        "COUNTRY": "Vælg et land",
        "ADD": "Tilføj en landesignatur",
        "REMOVE": "Fjern"
      },
      "PHONE_DIALING_PREFIX": {
        "LABEL": "Opkaldspræfiks for telefonnummer",
        "PLACEHOLDER": "Angiv præfiks for korrekt opkaldsdirigering (f.eks. *99)",
        "HELP_TEXT": "Dette præfiks tilføjes automatisk foran kontaktens telefonnummer, når der ringes fra denne indbakke."
      },
      "RESOLVE_LATER_TEXT": {
        "LABEL": "Tekst til knappen „Løs senere“",
        "PLACEHOLDER": "f.eks. Vi løser dette emne via e-mail. Jeg vil gerne spørge om noget andet nu.",
        "HELP_TEXT": "Tekst på widgettens knap, som lader den besøgende forlade det aktuelle emne og spørge om noget andet. Lad feltet stå tomt for at bruge standardteksten på den besøgendes sprog."
      },
      "AUTO_SNOOZE_MINUTES": {
        "LABEL": "Udsæt automatisk ubesvarede opkald i X minutter",
        "PLACEHOLDER": "0",
        "HELP_TEXT": "Udsæt automatisk ubesvarede opkald i det angivne antal minutter. Lad stå tomt eller 0 for at deaktivere."
      },
      "AUTO_RESOLVE_AFTER_FAILED_ATTEMPTS": {
        "LABEL": "Løs et ubesvaret opkald efter X mislykkede tilbagekald",
        "PLACEHOLDER": "0",
        "HELP_TEXT": "Når et ubesvaret opkald er blevet ringet tilbage X gange uden, at kunden har svaret, løses det automatisk, og der tilføjes en privat note. Lad stå tomt eller 0 for at deaktivere."
      },
      "QUESTION_SUGGESTIONS": {
        "TITLE": "Spørgeforslag",
        "SUB_TEXT": "Konfigurer foruddefinerede spørgsmål, som kunder kan bruge til at interagere med dine agenter.",
        "QUESTIONS_LABEL": "Spørgsmål",
        "ADD_QUESTION": "Tilføj spørgsmål",
        "REMOVE": "Fjern",
        "QUESTION_TEXT": "Tekst der vises i boblen.",
        "QUESTION_TEXT_PLACEHOLDER": "Påkrævet",
        "QUESTION_PAYLOAD": "Tekst der sendes, når der klikkes.",
        "QUESTION_PAYLOAD_PLACEHOLDER": "Valgfrit",
        "NO_BOT_MESSAGE": "Tilslut en bot for at generere flere AI-forslag.",
        "BOT_CONNECTED_MESSAGE": "AI-spørgeforslag fra botten kan aktiveres i dens",
        "BOT_SETTINGS_LINK": "indstillinger"
      },
      "ALTERNATIVE_EMAILS": {
        "TITLE": "Alternative e-mails",
        "SUB_TEXT": "Yderligere adresser, som denne indbakke skal behandle som sine egne, når den modtager videresendt post.",
        "PLACEHOLDER": "alias{'@'}example.com",
        "ADD": "Tilføj",
        "REMOVE": "Fjern",
        "EMPTY": "Ingen alternative e-mails konfigureret.",
        "HELP_TEXT": "Når en e-mail ankommer med en af disse adresser som modtager, sendes svar med samme adresse som afsender. Sørg for, at din udgående SMTP-server tillader afsendelse fra disse adresser.",
        "SIGNATURE_LABEL": "Signatur",
        "PRIMARY_SIGNATURE": "Primær (standard)"
      },
      "ADDITIONAL_SIGNATURES": {
        "TITLE": "Yderligere signaturer",
        "SUB_TEXT": "Definér ekstra signaturer her, og tildel dem derefter til de alternative e-mails nedenfor.",
        "OPTION": "Signatur {number}",
        "ADD": "Tilføj signatur",
        "REMOVE": "Fjern",
        "HELP_TEXT": "Når et svar sendes fra en alternativ e-mail, bruges den tildelte signatur i stedet for indbakkens signatur. Alternative e-mails, der er sat til »Primær (standard)«, falder tilbage til indbakkens signatur."
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Slet",
      "AVATAR_DELETE_BUTTON_TEXT": "Slet Avatar",
      "DELETE_REQUESTED_TOOLTIP": "Denne indbakke er markeret til sletning",
      "RESTORE_BUTTON_TEXT": "Gendan",
      "CONFIRM": {
        "TITLE": "Bekræft Sletning",
        "MESSAGE": "Er du sikker på du vil slette ",
        "PLACE_HOLDER": "Skriv venligst {inboxName} for at bekræfte",
        "YES": "Ja, Slet ",
        "NO": "Nej, Behold "
      },
      "API": {
        "SUCCESS_MESSAGE": "Indbakken blev slettet",
        "MARKED_FOR_DELETION_MESSAGE": "Indbakken er markeret til sletning",
        "RESTORE_SUCCESS_MESSAGE": "Indbakken blev gendannet",
        "ERROR_MESSAGE": "Kunne ikke slette indbakken. Prøv igen senere.",
        "RESTORE_ERROR_MESSAGE": "Kunne ikke gendanne indbakken. Prøv igen senere.",
        "AVATAR_SUCCESS_MESSAGE": "Indbakke avatar slettet",
        "AVATAR_ERROR_MESSAGE": "Kunne ikke slette indbakken avatar. Prøv igen senere."
      }
    },
    "TABS": {
      "SETTINGS": "Indstillinger",
      "COLLABORATORS": "Samarbejdspartnere",
      "AUTOMATIC_PRIORITY": "Automatisk prioritet",
      "AUTOMATIC_LABELING": "Automatisk etikettering",
      "CONFIGURATION": "Konfiguration",
      "CAMPAIGN": "Kampagner",
      "PRE_CHAT_FORM": "Pre Chat Form",
      "BUSINESS_HOURS": "Forretningstider",
      "WIDGET_BUILDER": "Widget Builder",
      "BOT_CONFIGURATION": "Bot konfiguration",
      "SLA": "SLA"
    },
    "SETTINGS": "Indstillinger",
    "FEATURES": {
      "LABEL": "Funktioner",
      "DISPLAY_FILE_PICKER": "Vis filvælger på widget'en",
      "DISPLAY_EMOJI_PICKER": "Vis emoji-vælger på widget'en",
      "ALLOW_END_CONVERSATION": "Tillad brugere at afslutte samtale fra widget",
      "SHOW_START_NEW_CONVERSATION_BUTTON": "Vis knappen 'Start en ny samtale' i widgettens header",
      "HIDE_INPUT_UNDER_START_NEW_CONVERSATION_BUTTON": "Hide input field when start new conversation button is shown",
      "SHOW_HANDOFF_BUTTON": "Vis knappen 'Overfør til en operatør' i widgettens header",
      "AUTO_CLOSE_OLD": "Markér alle tidligere opkald fra samme nummer som løst, når ét er løst",
      "AUTO_ASSIGN_MISSED_ON_OUTGOING": "Tildel automatisk ubesvarede opkald, når der foretages et udgående opkald",
      "USE_INBOX_AVATAR_FOR_BOT": "Use inbox name and avatar for the bot",
      "ALLOW_OFFLINE_REPLY": "Tillad agenter at sende beskeder, når kontakten er offline, og e-mailkontinuitet ikke er tilgængelig"
    },
    "SETTINGS_POPUP": {
      "MESSENGER_HEADING": "Messenger- Script",
      "MESSENGER_SUB_HEAD": "Placer denne knap inde i din body tag",
      "INBOX_AGENTS": "Agenter",
      "INBOX_TEAMS": "Teams",
      "INBOX_COOPERATORS": "Samarbejdspartnere",
      "SELECT_PLACEHOLDER": "Vælg",
      "AGENTS_OR_TEAMS_INFO": "Du kan tildele enten agenter eller teams - ikke begge dele samtidig.",
      "INBOX_AGENTS_SUB_TEXT": "Tilføj eller fjern agenter fra denne indbakke",
      "AGENT_ASSIGNMENT": "Samtale Tildeling",
      "AGENT_ASSIGNMENT_SUB_TEXT": "Opdater indstillinger for samtale",
      "UPDATE": "Opdater",
      "ENABLE_EMAIL_COLLECT_BOX": "Aktiver boks til indsamling af e-mail",
      "ENABLE_EMAIL_COLLECT_BOX_SUB_TEXT": "Aktiver eller deaktivér opsamlingsboks for e-mail ved ny samtale",
      "AUTO_ASSIGNMENT": "Aktiver automatisk tildeling",
      "ENABLE_CSAT": "Aktiver CSAT",
      "ENABLE_CSAT_ON_EACH_MESSAGE": "Aktiver CSAT på hver besked",
      "SENDER_NAME_SECTION": "Enable Agent Name in Email",
      "ENABLE_CSAT_SUB_TEXT": "Aktiver/deaktivér CSAT(Customer satisfaction) undersøgelse efter at have løst en samtale",
      "ENABLE_CSAT_ON_EACH_MESSAGE_SUB_TEXT": "Aktiver/deaktiver CSAT-undersøgelse for hver besked sendt af agenter",
      "SENDER_NAME_SECTION_TEXT": "Enable/Disable showing Agent's name in email, if disabled it will show business name",
      "ENABLE_CONTINUITY_VIA_EMAIL": "Aktivér konversationskontinuitet via e-mail",
      "ENABLE_CONTINUITY_VIA_EMAIL_SUB_TEXT": "Samtaler vil fortsætte via e-mail, hvis kontaktpersonens e-mailadresse er tilgængelig.",
      "RESPOND_FROM_EMAIL": "Svar fra e-mail",
      "RESPOND_FROM_EMAIL_SUB_TEXT_WEBWIDGET": "E-mails til kunden — både svar og samtaleudskrifter — sendes med SMTP-indstillingerne for den valgte e-mailindbakke fra den valgte adresse (indbakkens egen adresse eller et af dens aliasser), og kundens svar modtages tilbage via dens IMAP-adresse.",
      "RESPOND_FROM_EMAIL_SUB_TEXT_OTHER": "Samtaleudskrifter sendes med SMTP-indstillingerne for den valgte e-mailindbakke fra den valgte adresse (indbakkens egen adresse eller et af dens aliasser), og svar modtages tilbage via dens IMAP-adresse.",
      "SHOW_WELCOME_SCREEN": "Vis velkomstskærm",
      "SHOW_WELCOME_SCREEN_TOOLTIP": "Vis velkomstskærmen, når widgetten åbnes. Hvis deaktiveret, går widgetten direkte til samtalevisningen.",
      "AUTO_CLOSE_PENDING": "Løs automatisk AI-chats efter (timer)",
      "AUTO_CLOSE_PENDING_SUB_TEXT": "Løs automatisk AI-chats efter X timers inaktivitet.",
      "LOCK_TO_SINGLE_CONVERSATION": "Lock to single conversation",
      "LOCK_TO_SINGLE_CONVERSATION_SUB_TEXT": "Enable or disable multiple conversations for the same contact in this inbox",
      "INBOX_UPDATE_TITLE": "Indbakke Indstillinger",
      "INBOX_UPDATE_SUB_TEXT": "Opdater dine indbakkeindstillinger",
      "AUTO_ASSIGNMENT_SUB_TEXT": "Aktiver eller deaktiver automatisk tildeling af nye samtaler til agenter tilføjet til denne indbakke.",
      "HMAC_VERIFICATION": "Bruger Identitetsvalidering",
      "HMAC_DESCRIPTION": "For at validere brugerens identitet, kan du passere en `identifier_hash` for hver bruger. Du kan generere en HMAC sha256 hash ved hjælp af 'identifier' med nøglen vist her.",
      "HMAC_ROTATE": {
        "BUTTON": "Roter nøgle",
        "TITLE": "Vil du rotere den hemmelige nøgle?",
        "WARNING": "Den nuværende nøgle tilbagekaldes, i det øjeblik du roterer den.",
        "WARNING_DETAIL": "Der er ingen overlapningsperiode, og nøglen kan ikke gendannes.",
        "IMPACT": "Dine servere skal signere brugere med den nye nøgle. Alle, der stadig er signeret med den gamle, fejler i verifikationen. Hvis identitetsvalidering er påkrævet, kan de ikke starte en samtale.",
        "CONFIRM": "Roter nøgle",
        "CANCEL": "Annuller",
        "SUCCESS": "Hemmelig nøgle roteret",
        "ERROR": "Kunne ikke rotere den hemmelige nøgle. Prøv igen"
      },
      "HMAC_LINK_TO_DOCS": "You can read more here.",
      "HMAC_MANDATORY_VERIFICATION": "Gennemtving Validering Af Bruger Identitet",
      "HMAC_MANDATORY_DESCRIPTION": "Hvis aktiveret, vil forespørgsler der mangler 'identifier_hash' blive afvist.",
      "FORCE_NEW_CONVERSATION_PER_LOAD_TITLE": "Gennemtving ny samtale ved hver indlæsning af widget",
      "FORCE_NEW_CONVERSATION_PER_LOAD_SUBTITLE": "Hvis aktiveret, starter en ny samtale, når widgetten åbnes i en ny fane eller et nyt vindue.",
      "NEW_CONVERSATION_FORGETS_CONTACT_TITLE": "Glem kontakten, når en ny samtale startes",
      "NEW_CONVERSATION_FORGETS_CONTACT_SUBTITLE": "Hvis deaktiveret, bevarer en ny samtale startet fra widgetten den forrige kontakt.",
      "INBOX_IDENTIFIER": "Identifikator For Indbakke",
      "INBOX_IDENTIFIER_SUB_TEXT": "Brug den `inbox_identifier` token vist her til godkendelse dine API-klienter.",
      "FORWARD_EMAIL_TITLE": "Videresend til e-mail",
      "FORWARD_EMAIL_SUB_TEXT": "Begynd at videresende dine e-mails til følgende e-mailadresse.",
      "EMAIL_FETCHING_ENABLED_TITLE": "E-mailsynkronisering",
      "EMAIL_FETCHING_ENABLED_DESCRIPTION": "Aktiver automatisk synkronisering og download af indgående e-mails fra denne indbakke",
      "CUSTOM_EMAIL_ENABLED_TITLE": "Tilpasset e-maildomæne",
      "CUSTOM_EMAIL_ENABLED_DESCRIPTION": "Aktiver for at bruge et tilpasset e-maildomæne til udgående e-mails",
      "CUSTOM_EMAIL_ENABLED_LINK_TO_DOCS": "Du kan læse mere her.",
      "FACEBOOK_COMMENTS_TITLE": "Facebook-kommentarer",
      "ALLOW_MESSAGES_AFTER_RESOLVED": "Tillad beskeder efter samtalen løst",
      "ALLOW_MESSAGES_AFTER_RESOLVED_SUB_TEXT": "Tillad slutbrugere at sende beskeder, selv efter samtalen er løst.",
      "WIDGET_STATUS_LABEL": "Widget-status",
      "WIDGET_STATUS_ENABLED": "Aktiveret",
      "WIDGET_STATUS_BUSINESS_HOURS": "Aktiveret i åbningstiden",
      "WIDGET_STATUS_DISABLED": "Deaktiveret",
      "WIDGET_STATUS_HELP_TEXT": "Styr hvornår widgetten vises for besøgende på din hjemmeside",
      "UPDATE_PRE_CHAT_FORM_SETTINGS": "Update Pre Chat Form Settings",
      "EXPLICIT_CSAT_LOCALE": "Sprog for CSAT-undersøgelse og e-mail",
      "EXPLICIT_CSAT_LOCALE_SUB_TEXT": "Vælg sproget for alle kunde-e-mails, herunder CSAT-undersøgelser, samtaleudskrifter og e-mailnotifikationer",
      "EXPLICIT_CSAT_LOCALE_INHERIT": "Overtag fra konto",
      "WHATSAPP_CONNECTION": {
        "TITLE": "WhatsApp-forbindelse",
        "SUBTITLE": "Sådan er denne indbakke forbundet til WhatsApp.",
        "PROVIDER": "Udbyder",
        "PROVIDER_VALUE": "WhatsApp Cloud API (Meta)",
        "EMBEDDED_SIGNUP": "Forbundet via Metas indlejrede tilmelding",
        "STATUS": "Status",
        "CONNECTED": "Forbundet",
        "RECONNECT_HINT": "Klik på Forbind igen i meddelelsen ovenfor.",
        "PHONE_NUMBER": "Telefonnummer",
        "BUSINESS_ACCOUNT": "WhatsApp Business-konto-ID",
        "OPEN_MANAGER": "Åbn i WhatsApp Manager",
        "PHONE_NUMBER_ID": "Telefonnummer-ID",
        "TEMPLATES": "Beskedskabeloner",
        "TEMPLATES_COUNT": "{approved} af {total} godkendt",
        "TEMPLATES_SYNCED": "Senest synkroniseret {date}",
        "TEMPLATES_NOT_SYNCED": "Ikke synkroniseret endnu",
        "MANAGE_TEMPLATES": "Administrer skabeloner"
      }
    },
    "HELP_CENTER": {
      "LABEL": "Help Center",
      "PLACEHOLDER": "Select Help Center",
      "SELECT_PLACEHOLDER": "Select Help Center",
      "REMOVE": "Remove Help Center",
      "SUB_TEXT": "Attach a Help Center with the inbox"
    },
    "AUTO_ASSIGNMENT": {
      "MAX_ASSIGNMENT_LIMIT": "Grænse for automatisk tildeling",
      "MAX_ASSIGNMENT_LIMIT_RANGE_ERROR": "Indtast en værdi større end 0",
      "MAX_ASSIGNMENT_LIMIT_SUB_TEXT": "Begræns det maksimale antal samtaler fra denne indbakke, der kan være auto tildelt en agent"
    },
    "SLA": {
      "TITLE": "SLA-politikker",
      "SUB_TEXT": "Konfigurer SLA-svar- og løsningstider for hvert prioritetsniveau for samtaler.",
      "LOADING": "Indlæser SLA-politikker...",
      "FIELDS": {
        "ACTIVE": "Aktiv",
        "TICKET_PRIORITY": "Samtaleprioritet",
        "FIRST_RESPONSE_TIME": "Første svartid",
        "EVERY_RESPONSE_TIME": "Hver svartid",
        "RESOLUTION_TIME": "Løsningstid",
        "PLACEHOLDER": "f.eks. 1t 30m"
      },
      "API": {
        "SUCCESS_MESSAGE": "SLA-politikkerne blev opdateret.",
        "ERROR_MESSAGE": "Kunne ikke opdatere SLA-politikkerne. Prøv venligst igen."
      }
    },
    "AUTOMATIC_PRIORITY": {
      "TITLE": "Automatisk prioritet",
      "SUB_TEXT": "Konfigurer automatisk tildeling af prioritet baseret på samtalens indhold.",
      "BILLING_DISCLAIMER": {
        "TITLE": "Faktureringsbemærkning",
        "MESSAGE": "Hver prioritetsvurdering medfører en omkostning. Se venligst dine abonnementsoplysninger for prisinformation."
      },
      "MODE": {
        "OFF": "Fra",
        "ALL_MESSAGES": "Til for alle indgående beskeder",
        "FIRST_MESSAGE": "Til kun for den første indgående besked"
      },
      "PRIORITY_LEVELS": {
        "TITLE": "Konfiguration af prioritetsniveau",
        "SUB_TEXT": "Konfigurer hvilke prioritetsniveauer der skal være aktiveret, og deres beskrivelser. Angiv klare kriterier, så AI kan afgøre, hvornår denne prioritet skal tildeles."
      },
      "DESCRIPTION_LABEL": "Beskrivelse",
      "DESCRIPTION_PLACEHOLDER": "Beskriv samtaler, der skal markeres med prioriteten {priority}",
      "SET_AS_DEFAULT": "Angiv som standardprioritet",
      "MULTIPLE_DEFAULTS_WARNING": "Kun ét prioritetsniveau bør være standard. Fjern venligst markeringen for de andre."
    },
    "AUTOMATIC_LABELING": {
      "TITLE": "Automatisk etikettering",
      "SUB_TEXT": "Konfigurer automatisk tildeling af etiketter baseret på samtalens indhold.",
      "BILLING_DISCLAIMER": {
        "TITLE": "Faktureringsbemærkning",
        "MESSAGE": "Hver etiketteringsvurdering medfører en omkostning. Se venligst dine abonnementsoplysninger for prisinformation."
      },
      "MODE": {
        "OFF": "Fra",
        "CONVERSATION_OPEN": "Ved åbning af samtale",
        "CONVERSATION_CLOSE": "Ved lukning af samtale",
        "ALL_MESSAGES": "Ved hver besked - uanset status",
        "FIRST_MESSAGE": "Ved første besked - uanset status"
      },
      "LABEL_CONFIGURATION": {
        "TITLE": "Konfiguration af etiketter",
        "SUB_TEXT": "Konfigurer hvilke etiketter der skal være tilgængelige til automatisk tildeling, og deres beskrivelser. Angiv klare kriterier, så AI kan afgøre, hvornår denne etiket skal bruges."
      },
      "DESCRIPTION_LABEL": "Beskrivelse",
      "DESCRIPTION_PLACEHOLDER": "Beskriv samtaler, der skal have etiketten {label}. Hvis feltet efterlades tomt, bruges etikettens beskrivelse.",
      "NO_LABELS_MESSAGE": "Ingen etiketter fundet. Opret etiketter først for at aktivere automatisk etikettering.",
      "CREATE_LABELS_LINK": "Opret etiketter"
    },
    "FACEBOOK_REAUTHORIZE": {
      "TITLE": "Genautorisér",
      "SUBTITLE": "Din Facebook-forbindelse er udløbet, tilslut venligst din Facebook-side igen for at fortsætte tjenesterne",
      "MESSAGE_SUCCESS": "Genoprettelse lykkedes",
      "MESSAGE_ERROR": "Der opstod en fejl, prøv igen"
    },
    "PRE_CHAT_FORM": {
      "DESCRIPTION": "Forud chat formularer gør det muligt for dig at fange brugeroplysninger, før de starter samtale med dig.",
      "SET_FIELDS": "Tidligere chatformularfelter",
      "SET_FIELDS_HEADER": {
        "FIELDS": "Felter",
        "LABEL": "Etiketter",
        "PLACE_HOLDER": "Pladsholder",
        "KEY": "Nøgle",
        "TYPE": "Type",
        "REQUIRED": "Påkrævet"
      },
      "ENABLE": {
        "LABEL": "Aktiver præ-chat formular",
        "OPTIONS": {
          "ENABLED": "Ja",
          "DISABLED": "Nej"
        }
      },
      "PRE_CHAT_MESSAGE": {
        "LABEL": "Tidligere chatbesked",
        "PLACEHOLDER": "Denne meddelelse vil være synlig for brugerne sammen med formularen"
      },
      "REQUIRE_EMAIL": {
        "LABEL": "Besøgende skal angive deres navn og e-mailadresse, før du starter chatten"
      }
    },
    "BUSINESS_HOURS": {
      "TITLE": "Indstil din tilgængelighed",
      "SUBTITLE": "Indstil din tilgængelighed på din livechat widget",
      "WEEKLY_TITLE": "Indstil dine ugentlige timer",
      "TIMEZONE_LABEL": "Vælg tidszone",
      "UPDATE": "Opdater indstillinger for åbningstider",
      "TOGGLE_AVAILABILITY": "Aktiver forretningstilgængelighed for denne indbakke",
      "UNAVAILABLE_MESSAGE_LABEL": "Utilgængelig besked til besøgende",
      "TOGGLE_HELP": "Enabling business availability will show the available hours on live chat widget even if all the agents are offline. Outside available hours visitors can be warned with a message and a pre-chat form.",
      "DAY": {
        "ENABLE": "Aktiver tilgængelighed for denne dag",
        "UNAVAILABLE": "Unavailable",
        "HOURS": "timer",
        "VALIDATION_ERROR": "Starttidspunkt bør være før lukketid.",
        "CHOOSE": "Vælg"
      },
      "ALL_DAY": "All-Day",
      "SAVE_TO_ALL": "Gem til alle indbakker",
      "SAVE_TO_ALL_TITLE": "Kopier åbningstider",
      "SAVE_TO_ALL_CONFIRM": "Indstillingerne fra denne formular (tilgængelighedsknap, fraværsbesked, tidszone og åbningstider) kopieres til alle andre indbakker, undtagen e-mail- og telefonindbakker. Er du sikker på, at du vil fortsætte?",
      "SAVE_TO_ALL_CANCEL": "Annuller",
      "SAVE_TO_ALL_YES": "Ja, kopier til alle",
      "SAVE_TO_ALL_SUCCESS": "Åbningstiderne blev kopieret til alle andre indbakker",
      "SAVE_TO_ALL_ERROR": "Kunne ikke kopiere åbningstiderne til andre indbakker"
    },
    "PHONE": {
      "TITLE": "Telefonindstillinger",
      "SUBTITLE": "Konfigurer hvilke opkald der skal vises under denne indbakke.",
      "UPDATE": "Gem indstillinger",
      "EDIT": {
        "SUCCESS_MESSAGE": "Telefonindstillingerne blev opdateret"
      },
      "PHONE_NUMBERS": {
        "LABEL": "Telefonnumre",
        "PLACEHOLDER": "+145123908635"
      }
    },
    "IMAP": {
      "TITLE": "IMAP",
      "SUBTITLE": "Indstil dine IMAP-oplysninger",
      "NOTE_TEXT": "For at aktivere SMTP skal du konfigurere IMAP.",
      "UPDATE": "Opdater indstillinger",
      "TOGGLE_AVAILABILITY": "Aktiver IMAP- konfiguration for denne indbakke",
      "TOGGLE_HELP": "Enabling IMAP will help the user to receive email",
      "EDIT": {
        "SUCCESS_MESSAGE": "Indbakkeindstillinger opdateret",
        "ERROR_MESSAGE": "Kunne ikke opdatere IMAP-indstillinger"
      },
      "ADDRESS": {
        "LABEL": "Ip Adresse",
        "PLACE_HOLDER": "Adresse (f.eks.: imap.gmail.com)"
      },
      "PORT": {
        "LABEL": "Port",
        "PLACE_HOLDER": "Port"
      },
      "LOGIN": {
        "LABEL": "Log Ind",
        "PLACE_HOLDER": "Log Ind"
      },
      "PASSWORD": {
        "LABEL": "Adgangskode",
        "PLACE_HOLDER": "Adgangskode"
      },
      "ENABLE_SSL": "Aktiver SSL"
    },
    "MICROSOFT": {
      "TITLE": "Microsoft",
      "SUBTITLE": "Reauthorize your MICROSOFT account"
    },
    "SMTP": {
      "TITLE": "Smtp",
      "SUBTITLE": "Indstil dine IMAP-oplysninger",
      "UPDATE": "Opdater SMTP indstillinger",
      "TOGGLE_AVAILABILITY": "Aktiver SMTP konfiguration for denne indbakke",
      "TOGGLE_HELP": "Aktivering af SMTP vil hjælpe brugeren med at sende e-mail",
      "EDIT": {
        "SUCCESS_MESSAGE": "SMTP indstillinger opdateret",
        "ERROR_MESSAGE": "Kan ikke opdatere SMTP indstillinger"
      },
      "ADDRESS": {
        "LABEL": "Ip Adresse",
        "PLACE_HOLDER": "Adresse (f.eks.: smtp.gmail.com)"
      },
      "PORT": {
        "LABEL": "Port",
        "PLACE_HOLDER": "Port"
      },
      "LOGIN": {
        "LABEL": "Log Ind",
        "PLACE_HOLDER": "Log Ind"
      },
      "PASSWORD": {
        "LABEL": "Adgangskode",
        "PLACE_HOLDER": "Adgangskode"
      },
      "DOMAIN": {
        "LABEL": "Domæne",
        "PLACE_HOLDER": "Domæne"
      },
      "ENCRYPTION": "Kryptering",
      "SSL_TLS": "SSL/TLS",
      "START_TLS": "STARTTLS",
      "OPEN_SSL_VERIFY_MODE": "Åbn SSL-bekræftelsestilstand",
      "AUTH_MECHANISM": "Godkendelse"
    },
    "EMAIL_DNS_CHECK": {
      "TITLE": "Leveringsevne for e-mail (DNS)",
      "SUB_TITLE": "Vi kontrollerer SPF-, DKIM-, DMARC- og MX-posterne for {domain} hver hverdag. Når noget får modtagende servere til at afvise dine svar eller lægge dem i spam, får administratorerne en e-mail med løsningen.",
      "RUN": "Kør kontrol",
      "RUN_SUCCESS": "DNS-kontrollen er færdig",
      "RUN_ERROR": "DNS-kontrollen kunne ikke køres. Prøv igen.",
      "NOT_CHECKED": "Ikke kontrolleret endnu.",
      "CHECKED_AT": "Sidst kontrolleret {time}.",
      "DNS_UNAVAILABLE": "Den seneste kontrol fik intet svar fra domænets navneservere. Resultatet nedenfor stammer fra kontrollen før.",
      "SENDER": {
        "SMTP": "Svar sendes via {host}.",
        "PLATFORM": "Svar sendes via vores mailservere."
      },
      "STATUS": {
        "OK": "Alle poster er i orden",
        "WARNING": "Nogle poster kunne være bedre",
        "ERROR": "Svar når muligvis ikke frem til modtagerne",
        "UNKNOWN": "Ukendt"
      },
      "SEVERITY": {
        "ERROR": "Problem",
        "WARNING": "Advarsel"
      },
      "FIX": "Ret det med denne DNS-post:",
      "RECORD_TYPE": "Type",
      "RECORD_HOST": "Navn",
      "RECORD_VALUE": "Værdi",
      "ISSUES": {
        "spf_missing": {
          "TITLE": "SPF-post mangler",
          "DESCRIPTION": "Domænet oplyser ikke, hvilke servere der må sende e-mail for det. Mange mailservere behandler derfor dine svar som spam. Opret en SPF-post, der tillader {sender}."
        },
        "spf_multiple": {
          "TITLE": "Domænet har {count} SPF-poster",
          "DESCRIPTION": "Et domæne må kun have én SPF-post. Er der flere, ignorerer modtagende servere SPF og afviser ofte e-mailen. Slå dem sammen til én post."
        },
        "spf_not_authorized": {
          "TITLE": "SPF tillader ikke den server, der sender dine svar",
          "DESCRIPTION": "Dine svar sendes via {sender}, men domænets SPF-post nævner den ikke. Nuværende post: {record}"
        },
        "spf_too_many_lookups": {
          "TITLE": "SPF-posten kræver for mange DNS-opslag",
          "DESCRIPTION": "Modtagende servere holder op med at kontrollere SPF efter {limit} DNS-opslag, men {sender}, som sender dine svar, nås først efter {lookups}. Dine svar består derfor ikke SPF. Flyt {sender} til begyndelsen af posten, og fjern include-angivelser, som domænet ikke længere bruger."
        },
        "spf_lookups_others": {
          "TITLE": "Nogle afsendere i SPF-posten ligger efter opslagsgrænsen",
          "DESCRIPTION": "SPF-posten kræver {lookups} DNS-opslag, og modtagende servere stopper efter {limit}. Dine svar bliver genkendt i tide og består, men e-mails fra disse afsendere består ikke SPF: {senders}. Fjern include-angivelser, som domænet ikke længere bruger."
        },
        "spf_malformed": {
          "TITLE": "SPF-posten er ugyldig",
          "DESCRIPTION": "Modtagende servere kan ikke læse domænets SPF-post, så den beskytter ikke dine svar. Problemet findes i: {terms}. Erstat posten med den rettede udgave."
        },
        "dkim_missing": {
          "TITLE": "DKIM-signatur er ikke sat op",
          "DESCRIPTION": "Vi fandt ingen DKIM-nøgle på {selectors}. Uden den er dine svar ikke signeret, og de havner oftere i spam. Slå DKIM-signering til for domænet hos din e-mailudbyder."
        },
        "dmarc_missing": {
          "TITLE": "DMARC-post mangler",
          "DESCRIPTION": "Store mailudbydere som Gmail og Microsoft forventer en DMARC-post. Uden den havner dine svar oftere i spam."
        },
        "dmarc_fails": {
          "TITLE": "DMARC beder modtagerne om at afvise dine svar",
          "DESCRIPTION": "Domænets DMARC-politik er »{policy}«, og dine svar består hverken SPF eller DKIM, så modtagerne afviser dem eller lægger dem i spam. Ret SPF og DKIM ovenfor."
        },
        "dmarc_blocks_platform": {
          "TITLE": "DMARC blokerer svar sendt via vores mailservere",
          "DESCRIPTION": "Denne indbakke sender svar via vores mailservere, men domænets DMARC-politik er »{policy}«, så modtagerne afviser dem eller lægger dem i spam. Sæt SMTP op på din egen mailserver til denne indbakke."
        },
        "mx_missing": {
          "TITLE": "Domænet har ingen MX-post",
          "DESCRIPTION": "Uden en MX-post kan ingen sende e-mail til domænet, så kunderne kan ikke besvare dine svar."
        }
      }
    },
    "NOTE": "Bemærk: ",
    "WIDGET_BUILDER": {
      "WIDGET_OPTIONS": {
        "AVATAR": {
          "LABEL": "Websted Avatar",
          "DELETE": {
            "API": {
              "SUCCESS_MESSAGE": "Avatar slettet",
              "ERROR_MESSAGE": "Der opstod en fejl. Prøv venligst igen"
            }
          }
        },
        "WEBSITE_NAME": {
          "LABEL": "Websted Navn",
          "PLACE_HOLDER": "Indtast dit websted navn (fx: Firma ApS)",
          "ERROR": "Please enter a valid website name"
        },
        "WELCOME_HEADING": {
          "LABEL": "Velkomstoverskrift",
          "PLACE_HOLDER": "Hej der!"
        },
        "WELCOME_TAGLINE": {
          "LABEL": "Velkomst Tagline",
          "PLACE_HOLDER": "Vi gør det nemt at komme i kontakt med os. Spørg os om noget, eller del din feedback."
        },
        "REPLY_TIME": {
          "LABEL": "Svar Tid",
          "IN_A_FEW_MINUTES": "På nogle få minutter",
          "IN_A_FEW_HOURS": "Om et par timer",
          "IN_A_DAY": "På en dag"
        },
        "WIDGET_COLOR_LABEL": "Widget Farve",
        "WIDGET_BUBBLE_POSITION_LABEL": "Widget Bubble Position",
        "UNREAD_MESSAGES_MAX_HEIGHT": {
          "LABEL": "Maks. højde for ulæste beskeder (px)",
          "PLACE_HOLDER": "Ingen grænse",
          "HELP_TEXT": "Begræns den maksimale højde på pop op-vinduet med ulæste beskeder i pixels. Lad feltet være tomt for standardadfærd (ingen grænse)."
        },
        "WIDGET_BUBBLE_TYPE_LABEL": "Widget Bubble Type",
        "WIDGET_BUBBLE_LAUNCHER_TITLE": {
          "DEFAULT": "Chat med os",
          "LABEL": "Widget Bubble Launcher Titel",
          "PLACE_HOLDER": "Chat med os"
        },
        "UPDATE": {
          "BUTTON_TEXT": "Opdater Widget Indstillinger",
          "API": {
            "SUCCESS_MESSAGE": "Widget-indstillinger opdateret",
            "ERROR_MESSAGE": "Kan ikke opdatere widget-indstillinger"
          }
        },
        "WIDGET_VIEW_OPTION": {
          "PREVIEW": "Eksempelvisning",
          "SCRIPT": "Script"
        },
        "WIDGET_BUBBLE_POSITION": {
          "LEFT": "Venstre",
          "RIGHT": "Højre"
        },
        "WIDGET_BUBBLE_TYPE": {
          "STANDARD": "Standard",
          "EXPANDED_BUBBLE": "Udvidet Boble"
        }
      },
      "WIDGET_SCREEN": {
        "DEFAULT": "Standard",
        "CHAT": "Chat"
      },
      "REPLY_TIME": {
        "IN_A_FEW_MINUTES": "Svarer typisk på et par minutter",
        "IN_A_FEW_HOURS": "Svarer typisk på et par timer",
        "IN_A_DAY": "Svarer typisk på en dag"
      },
      "FOOTER": {
        "START_CONVERSATION_BUTTON_TEXT": "Start Samtale",
        "CHAT_INPUT_PLACEHOLDER": "Skriv din besked"
      },
      "BODY": {
        "TEAM_AVAILABILITY": {
          "ONLINE": "Vi er online",
          "OFFLINE": "Vi er ikke tilgængelige i øjeblikket"
        },
        "USER_MESSAGE": "Hi",
        "AGENT_MESSAGE": "Hej"
      },
      "BRANDING_TEXT": "Drevet af JARABOT",
      "SCRIPT_SETTINGS": "\n      window.jarabotSettings = {options};"
    },
    "EMAIL_PROVIDERS": {
      "MICROSOFT": "Microsoft",
      "GOOGLE": "Google",
      "OTHER_PROVIDERS": "Other Providers"
    },
    "CHANNELS": {
      "MESSENGER": "Messenger",
      "WEB_WIDGET": "Hjemmeside",
      "TWITTER_PROFILE": "Twitter",
      "TWILIO_SMS": "Twilio SMS",
      "WHATSAPP": "WhatsApp",
      "SMS": "SMS",
      "SMS_BRANA": "SMS Brana",
      "DIDWW": "DIDWW",
      "EMAIL": "E-mail",
      "TELEGRAM": "Telegram",
      "LINE": "Line",
      "API": "API Kanal",
      "PHONE": "SIP-telefon",
      "INSTAGRAM": "Instagram",
      "SALESFORCE": "Salesforce",
      "ALLEGRO": "Allegro",
      "KAUFLAND": "Kaufland"
    }
  }
}
